import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {TagConfig, HttpStatusCodes, colorOptions} from '../../util/uiconstants';
import _ from 'lodash';
import Utility from '../../util/utilityfunctions';

export default function engagementtagsreducer(state = initialstate.engagementTags, action) {
	switch (action.type) {
		case types.CREATE_TAG_GROUP: {
			if (action.error) {
				return state;
			} else if (action.response) {
				// create new group object
				let recentlyAddedGroup = {
					groupName: action.meta.api.data.name,
					groupId: action.response.id,
					tags: []
				};

				// create new state object
				let mappedState = state.map((obj) => {
					return {...obj, tags: [...obj.tags]};
				});

				// add recent group in new state object
				mappedState.push(recentlyAddedGroup);

				//return new state
				//	return _.orderBy(mappedState, ["groupName"]);
				mappedState.sort(function(a, b) {
					return a.groupName.localeCompare(b.groupName);
				});
				return mappedState;
			}
			return state;
		}

		case types.ADD_TAG_GROUP: {
			if (action.error) {
				return state;
			} else if (action.response) {
				// create new group object
				let recentlyAddedGroup = {
					groupName: action.meta.api.data.name,
					groupId: action.response.id,
					tags: []
				};

				// create new state object
				let mappedState = state.map((obj) => {
					return {...obj, tags: [...obj.tags]};
				});

				// add recent group in new state object
				mappedState.push(recentlyAddedGroup);

				//return new state
				return mappedState;
			}
			return state;
		}

		case types.GET_ALL_ENGAGEMENT_TAGS:
			let tagGroups = Utility.getGroupedData(
				action.response?.data,
				TagConfig.groupByAttributeMapping,
				TagConfig.outputAttributesName
			);
			tagGroups.sort(function(a, b) {
				return a.groupName.localeCompare(b.groupName);
			});
			return tagGroups;

		case types.GET_ALL_TAGS:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;

		case types.CREATE_TAG:
			if (action.actiontype && action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Created) {
				// Add response object into state
				let newState = _.cloneDeep(state);
				if (action.response) {
					let tagGroupToBeUpdated = newState.filter(
						(tg) => tg.groupId === action.meta.api.data.engagementTagGroupId
					)[0];
					let newTag = {
						tagId: action.response.tagId,
						tagName: action.meta.api.data.name,
						colorCode: colorOptions[action.meta.api.data.colorCode].value,
						entityCount: 0
					};
					tagGroupToBeUpdated.tags =
						tagGroupToBeUpdated.tags.length > 0 ? [...tagGroupToBeUpdated.tags, newTag] : [newTag];
				}
				return newState;
			}
			return state;
		case types.UPDATE_TAG:
			if (action.actiontype && action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				// Add response object into state
				let newState = _.cloneDeep(state);
				if (action.response) {
					let tagGroupToBeUpdated = newState.filter(
						(tg) => tg.groupId === action.meta.api.data.engagementTagGroupId
					)[0];
					let tagIndex = tagGroupToBeUpdated.tags.findIndex((t) => t.tagId === action.meta.api.data.tagId);
					tagGroupToBeUpdated.tags[tagIndex].tagName = action.response.name;
					tagGroupToBeUpdated.tags[tagIndex].colorCode = action.response.colorCode;
				}
				return newState;
			}
			return state;
		case types.UPDATE_TAG_ENTITY_COUNT:
			if (action.data) {
				let newState = _.cloneDeep(state);

				// find and update tag entity count
				if (action.data.operation === 'add') {
					newState.map((group) => {
						return {
							...group,
							tags: group.tags.map((x) => {
								if (x.tagId === action.data.tag.tagId) {
									x.entityCount = x.entityCount + action.data.newEntityCount;
									return x;
								}
							})
						};
					});
				} else if (action.data.operation === 'remove') {
					newState.map((group) => {
						return {
							...group,
							tags: group.tags.map((x) => {
								if (x.tagId === action.data.tag.tagId) {
									x.entityCount =
										x.entityCount - action.data.newEntityCount < 0
											? x.entityCount
											: x.entityCount - action.data.newEntityCount;
									return x;
								}
							})
						};
					});
				}

				return newState;
			}

			return state;
		case types.DELETE_TAG:
			if (action.tag) {
				// get data
				let newState = _.cloneDeep(state);
				console.log(newState);
				let tagGroups = Utility.getGroupedData(
					newState,
					TagConfig.groupByAttributeMapping,
					TagConfig.outputAttributesName
				);
				tagGroups.sort(function(a, b) {
					return a.groupName.localeCompare(b.groupName);
				});
				newState.map((group) => {
					let filteredTags = group.tags.filter((i) => i.tagId !== action.tag.tagId);
					group.tags = filteredTags;
				});
				return newState;
			}
			return state;
		//We are not using engagement taggroup thats why we are not grouping
		case types.DELETE_ENGAGEMENT_TAG:
			if (action.tag) {
				return action.tag.data || state;
			}
			return state;
		default:
			return state;
	}
}

function associateTaskTag(state, taskTagIds) {
	return state.map((tg) => {
		return {
			...tg,
			tags: tg[TagConfig.outputAttributesName.groupChildrenListName].map((t) => {
				let checked = false;
				if (taskTagIds.indexOf(t[TagConfig.outputAttributesName.childId]) >= 0) {
					checked = true;
				}
				return {
					...t,
					checked: checked
				};
			})
		};
	});
}

export function buildTag(tag, tagGroup, taskId) {
	let taskTag = {
		colorCode: tag.colorCode,
		engagementTagGroupId: tagGroup.groupId,
		engagementTagGroupName: tagGroup.groupName,
		engagementTagId: tag.tagId,
		engagementTagName: tag.tagName,
		entityCount: 0,
		entityUIID: taskId
	};

	return taskTag;
}
